// 3 категории сложности:
// 1: 3-5 полосок
// 2: 6-8 полосок
// 3: 9-12 полосок
export const defaultDifficulty: number = 2 ;
export const defaultRestart:boolean = true ;
export enum PictureSet {
    DEVICES = 'DEVICES',
    RULES = 'RULES',
    YEAR3_LESSON7 = 'YEAR3_LESSON7',
    COMPETITION_0_1 = 'COMPETITION_0_1',
}

export const pictureSetMap: Map<PictureSet, string[]> = new Map()
    .set(PictureSet.DEVICES, [
        "cam",
        "cooler",
        "cpu",
        "keyboard",
        "memory",
        "mic",
        "monitor_pc",
        "mouse",
        "printer",
        "ram",
    ])
    .set(PictureSet.RULES, [
        "back",
        "dino",
        "fingers",
        "food",
        "monitor_rule",
        "rest",
        "socket",
        "start",
        "window",
        "wires",
    ])
    .set(PictureSet.YEAR3_LESSON7, [
        "acorns",
        "bumps",
        "nectar",
    ])
    .set(PictureSet.COMPETITION_0_1, [
        "wolf",
        "goat",
        "cabbage",
    ])
    ;